/**
 * nav.js — the only JavaScript on the page.
 *
 * Progressive enhancement over a plain disclosure button. Without this file the
 * menu is simply always open on small screens (see the `no-js` rules in the
 * stylesheet), so nothing becomes unreachable if the script fails to load.
 */

(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('site-nav');
  if (!toggle || !nav) return;

  var mobile = window.matchMedia('(max-width: 61.999rem)');

  function isOpen() {
    return toggle.getAttribute('aria-expanded') === 'true';
  }

  function setOpen(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('nav-open', open);
  }

  function close(returnFocus) {
    if (!isOpen()) return;
    setOpen(false);
    if (returnFocus) toggle.focus();
  }

  setOpen(false);

  toggle.addEventListener('click', function () {
    var open = !isOpen();
    setOpen(open);
    if (open) {
      // Move into the menu so a keyboard user lands on the first item.
      var first = nav.querySelector('a');
      if (first) first.focus();
    }
  });

  // Escape closes and hands focus back to the button that opened it.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close(true);
  });

  // Following a link in the menu closes it.
  nav.addEventListener('click', function (event) {
    if (event.target.closest('a')) close(false);
  });

  // Clicking or tabbing away closes it too.
  document.addEventListener('click', function (event) {
    if (!isOpen()) return;
    if (nav.contains(event.target) || toggle.contains(event.target)) return;
    close(false);
  });

  document.addEventListener('focusin', function (event) {
    if (!isOpen()) return;
    if (nav.contains(event.target) || toggle.contains(event.target)) return;
    close(false);
  });

  // Growing past the breakpoint leaves the desktop nav visible; drop the
  // open state so the button is not left claiming an expanded menu.
  function onBreakpoint(event) {
    if (!event.matches) close(false);
  }
  if (mobile.addEventListener) mobile.addEventListener('change', onBreakpoint);
  else if (mobile.addListener) mobile.addListener(onBreakpoint);
})();

/*
 * After the contact form posts, move focus to whichever outcome message came
 * back. `role="alert"` and `role="status"` announce themselves, but without
 * this a keyboard user is returned to the top of the document and has to hunt
 * for the result. Both messages carry tabindex="-1" so they can take focus
 * without entering the tab order.
 */
(function () {
  var outcome = document.querySelector('.cform__errors, .cform__ok');
  if (outcome) outcome.focus();
})();
